export const isValidHttpUrl = (url) => {
  return url.startsWith('http://') || url.startsWith('https://')
}
